import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124.171 21.34-.029 18.521.003 16",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M3.307 3.307 16 16 3.308 28.692C1.39 26.63.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .524-2.505 2.441-4.568",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M1.267 16.35c.117 2.9 1.974 4.385 5.4 4.383s5.282-1.486 5.4-4.384a.4.4 0 0 0-.8-.032c-.098 2.433-1.575 3.615-4.6 3.616-3.026.002-4.502-1.18-4.6-3.616a.4.4 0 0 0-.8.032"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M6.667 14.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M5.22 12.543c.471-.047 1.048.007 1.447.244.398-.237.975-.291 1.445-.244.257.047.87.098.87.098.487.033.928-.114 1.351-.308-.134.78-.283 1.579-.356 2.394-.16 1.209.56 2.223.264 3.417-.176.573-.792.906-1.356.972-.547.033-1.112.124-1.617.237-.094.02-.448.077-.608.314-.146-.237-.501-.295-.594-.314a10.6 10.6 0 0 0-1.617-.237c-.564-.066-1.18-.399-1.357-.972-.295-1.194.424-2.208.265-3.417-.074-.816-.223-1.614-.357-2.394.423.194.865.34 1.352.308 0 0 .612-.051.869-.098"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C2E7FF",
      fillRule: "evenodd",
      d: "M9.494 13.287a3 3 0 0 1-.568.018 21 21 0 0 1-.507-.049 8 8 0 0 1-.35-.045c-.038-.006-.038-.006-.023-.005-.403-.04-.814.02-1.039.154l-.34.203-.341-.203c-.22-.13-.62-.192-1.016-.156l-.046.007a8 8 0 0 1-.35.045c-.19.021-.38.038-.517.05a3 3 0 0 1-.557-.018c.09.551.14.935.178 1.352.075.57.022.985-.167 1.828l-.04.181c-.137.623-.162.968-.082 1.3.075.24.404.459.76.502a11 11 0 0 1 1.87.284q.15.038.294.1c.111-.038.211-.072.314-.098a11 11 0 0 1 1.84-.283c.393-.046.722-.264.787-.47.09-.367.065-.712-.071-1.335l-.04-.181c-.19-.843-.243-1.258-.17-1.8.039-.438.09-.827.18-1.38",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#BC715F",
      fillRule: "evenodd",
      d: "M6.775 11.702c.098-.01-.057.006-.185-.088-.13-.094-.158-.286.14-.28.295.006 1.403.061 1.424.15.02.088-.586.125-.81.12-.227-.005-.2.096.024.088.704-.022 1.471-.24 2.282.266.097.061-.245.071-.508-.028 0 0-.716.033-1.025-.012 0 0-.237.17-.547.154.04.089-.114.42-1.087.17-.161.044-.747.13-.683-.023-.154 0-.424.044-.465-.034-.038-.076.476-.191.567-.274 0 0-1.09.01-1.296-.057 0 0-.642.128-.604.017.056-.12.583-.45 2.31-.306 0 0 .292.158.463.137",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.767 15.788h-.21l1.52-.894v-.376h-.209L6.681 14l.812.518h-.21v.376l1.521.894h-.21v1.883h.21V18H4.557v-.33h.21z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagSxm = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagSxm_default = SvgFlagSxm;

export { FlagSxm_default as default };
